import { ViewerModule } from '@g.frame/core';
import { FBX_MODEL } from '@g.frame/common.loaders';
import { Mesh, MeshBasicMaterial } from 'three';
import { deepClone } from '../../../utils/DeepClone';
export class WoodenSignPlaceholderComponent extends ViewerModule {
    constructor(loader) {
        super();
        this.loader = loader;
        this.animationMultiplyer = 1;
        this.currentOpacity = 0.3;
        this.occupied = false;
        this.loader.addResources([
            {
                name: 'road_sign_model',
                type: FBX_MODEL,
                url: require('../../../../assets/models/leaves/road_sign.fbx')
            },
        ]);
    }
    init() {
        if (this.model)
            this.removeObject(this.model);
        this.model = deepClone(this.loader.getResource('road_sign_model'));
        this.addObject(this.model);
        this.model.children[0].position.setScalar(0);
        this.model.scale.setScalar(0.01);
        this.model.traverse(obj => {
            if (obj instanceof Mesh) {
                obj.material = new MeshBasicMaterial({ color: 'green', transparent: true, opacity: 0.5 });
            }
        });
    }
    update() {
        var _a;
        super.update();
        if (!this.uiObject.visible)
            return;
        this.currentOpacity += 0.003 * this.animationMultiplyer;
        if (this.currentOpacity > 0.5) {
            this.currentOpacity = 0.5;
            this.animationMultiplyer *= -1;
        }
        if (this.currentOpacity < 0.15) {
            this.currentOpacity = 0.15;
            this.animationMultiplyer *= -1;
        }
        (_a = this.model) === null || _a === void 0 ? void 0 : _a.traverse(obj => {
            if (obj instanceof Mesh) {
                // @ts-ignore
                obj.material.opacity = this.currentOpacity;
            }
        });
    }
}
